export default __webpack_public_path__ + "static/media/logo.002bb2b4.png";